export default {
    //[Field name]: [information tool message]
    'Volume Sampled': 'Units ml',
    'Volume Counted': 'Units ml',
    'SumOfDensity': 'Phytoplankton = cells/liter, Periphyton = cells/cm<sup>2</sup>',
}